export default class ClearInput{
    constructor(selector) {
        let iconsClear = document.querySelectorAll(selector);
        if (!iconsClear) {
            return false;
        }

        iconsClear.forEach(iconElement => {
            iconElement.addEventListener('click', event => {
                event.preventDefault();

                let self = event.target;
                let parentElement = self.parentNode.parentNode;

                let inputs = parentElement.querySelectorAll('input[type="text"]');
                if (!inputs) {
                    return false;
                }

                inputs.forEach(el => {
                    el.value = "";
                });

            });
        })
    }
}